// extracted by mini-css-extract-plugin
var _1 = "TestRankingElement_active__2ac98";
var _2 = "TestRankingElement_dnd__6f853";
var _3 = "TestRankingElement_hover__c20c5";
var _4 = "TestRankingElement_items__d9f48";
var _5 = "TestRankingElement_text__e2165";
var _6 = "TestRankingElement_wrapItem__8c447";
export { _1 as "active", _2 as "dnd", _3 as "hover", _4 as "items", _5 as "text", _6 as "wrapItem" }
